import React, { useContext, useEffect, useState } from "react";
import "./Profile.css";
import { ToastContainer, toast } from "react-toastify";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string } from "yup";
import Preloader from "../../Components/Loader/Loader";
import { BsArrowLeft } from "react-icons/bs";
import { Link, useNavigate, useLocation } from "react-router-dom";

const bankOptions = [
  "State Bank of India",
  "HDFC Bank",
  "ICICI Bank",
  "Axis Bank",
  "Punjab National Bank",
  "Bank of Baroda",
  "Canara Bank",
  "Union Bank of India",
  "IDBI Bank",
  "Indian Bank",
];

// const ValidateSchema = object({
//   first_name: string().required("First name is required"),
//   last_name: string().required("Last name is required"),
//   email: string().email("Enter a valid email").required("Email is required"),
//   pincode: string()
//     .required("Pincode is required")
//     .matches(/^[1-9][0-9]{5}$/, "Enter a valid 6-digit pincode"),
//   bank_name: string().required("Bank name is required"),
//   bank_account_number: string()
//     .required("Bank account number is required")
//     .matches(/^\d{9,18}$/, "Account number must be 9–18 digits"),
//   ifsc_code: string()
//     .required("IFSC Code is required")
//     .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter a valid IFSC code"),
// });

const BasicDetailsSchema = object({
  first_name: string().required("First name is required"),
  last_name: string().required("Last name is required"),
  email: string().email("Enter a valid email").required("Email is required"),
  pincode: string()
    .required("Pincode is required")
    .matches(/^[1-9][0-9]{5}$/, "Enter a valid 6-digit pincode"),
});

const BankDetailsSchema = object({
  bank_name: string().required("Bank name is required"),
  bank_account_number: string()
    .required("Bank account number is required")
    .matches(/^\d{9,18}$/, "Account number must be 9–18 digits"),
  ifsc_code: string()
    .required("IFSC Code is required")
    .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter a valid IFSC code"),
});

export function Profile() {
  const [activeTab, setActiveTab] = useState("basicdetails");
  const [loading, setLoading] = useState(false);
  const [isFocusedAccountNumber, setIsFocusedAccountNumber] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    if (location.state?.tab) {
      setActiveTab(location.state.tab);
    }
  }, [location.state]);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile_no: "",
      door_no: "",
      street: "",
      area: "",
      city: "",
      district: "",
      state: "",
      country: "",
      pincode: "",
      bank_name: "",
      bank_account_number: "",
      ifsc_code: "",
    },
    validationSchema:
      activeTab === "basicdetails" ? BasicDetailsSchema : BankDetailsSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        let payload = {};
        if (activeTab === "basicdetails") {
          payload = {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            mobile_no: values.mobile_no,
            door_no: values.door_no,
            street: values.street,
            area: values.area,
            city: values.city,
            district: values.district,
            state: values.state,
            country: values.country,
            pincode: values.pincode,
          };
        } else if (activeTab === "bankdetails") {
          payload = {
            bank_name: values.bank_name,
            bank_account_number: values.bank_account_number,
            ifsc_code: values.ifsc_code,
          };
        }

        const userId = localStorage.getItem("user_id");
        if (!userId) {
          toast.error("User ID not found. Please reload the page.");
          return;
        }

        const response = await axiosInstance.put(
          `/agent/registration/${userId}/`,
          payload,
        );

        if (
          response.data?.status === "success" ||
          response.data?.status === true
        ) {
          toast.success(
            // response.data?.message ||
            "Profile updated successfully!",
          );
          LoadProfile();
          setTimeout(() => {
            navigate("/home");
          }, 1200);
        } else {
          toast.error(
            response.data?.message || "Something went wrong, please try again!",
          );
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error(
          error.response?.data?.message ||
            "Submission failed! Please try again.",
        );
      } finally {
        setLoading(false);
      }
    },
  });

  async function LoadProfile() {
    try {
      const response = await axiosInstance.get("/agent/registration/");
      const { data } = response.data;
      if (data) {
        formik.setValues({
          first_name: data.first_name || "",
          last_name: data.last_name || "",
          email: data.email || "",
          mobile_no: data.mobile_no || "",
          door_no: data.door_no || "",
          street: data.street || "",
          area: data.area || "",
          city: data.city || "",
          district: data.district || "",
          state: data.state || "",
          country: data.country || "",
          pincode: data.pincode || "",
          bank_name: data.bank_name || "",
          bank_account_number: data.bank_account_number || "",
          ifsc_code: data.ifsc_code || "",
        });
      }
    } catch (error) {
      console.error("Error fetching user details", error);
    }
  }

  useEffect(() => {
    LoadProfile();
  }, []);

  const getMaskedAccountNumber = (number) => {
    if (!number || number.length < 4) return number || "";
    return number.slice(0, -3).replace(/./g, "X") + number.slice(-3);
  };

  return (
    <>
      {loading && <Preloader />}
      <ToastContainer />
      <div className="matchmakerEditBg">
        <div className="container">
          <div className="profileImgContainer">
            <Link to="/home" className="textBack">
              <div className="textBack">
                <BsArrowLeft className="me-1" />
                Back
              </div>
            </Link>
          </div>

          <div className="profile-tabs">
            <button
              type="button"
              onClick={() => setActiveTab("basicdetails")}
              className={
                activeTab === "basicdetails" ? "active-profiletab" : ""
              }
            >
              Basic Details
            </button>
            <button
              type="button"
              onClick={() => setActiveTab("bankdetails")}
              className={activeTab === "bankdetails" ? "active-profiletab" : ""}
            >
              Bank Details
            </button>
          </div>

          <form onSubmit={formik.handleSubmit}>
            {activeTab === "basicdetails" && (
              <div className="detailsContainer">
                {/* First & Last Name */}
                <div className="detailsGrid">
                  <div>
                    <label htmlFor="first_name">
                      <span className="text-danger">*</span> First Name
                    </label>
                    <input
                      type="text"
                      id="first_name"
                      name="first_name"
                      value={formik.values.first_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.first_name && formik.errors.first_name && (
                      <div className="error-message-signIn">
                        {formik.errors.first_name}
                      </div>
                    )}
                  </div>
                  <div>
                    <label htmlFor="last_name">
                      <span className="text-danger">*</span> Last Name
                    </label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      value={formik.values.last_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.last_name && formik.errors.last_name && (
                      <div className="error-message-signIn">
                        {formik.errors.last_name}
                      </div>
                    )}
                  </div>
                </div>

                {/* Email & Mobile */}
                <div className="detailsGrid">
                  <div>
                    <label htmlFor="email">
                      <span className="text-danger">*</span> Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="error-message-signIn">
                        {formik.errors.email}
                      </div>
                    )}
                  </div>
                  <div>
                    <label htmlFor="mobile_no">
                      <span className="text-danger">*</span> Mobile
                    </label>
                    <input
                      type="text"
                      id="mobile_no"
                      name="mobile_no"
                      value={formik.values.mobile_no}
                      readOnly
                    />
                  </div>
                </div>

                {/* Address Fields */}
                <div className="detailsGrid">
                  <div>
                    <label>Door No</label>
                    <input
                      type="text"
                      name="door_no"
                      value={formik.values.door_no}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  <div>
                    <label>Street</label>
                    <input
                      type="text"
                      name="street"
                      value={formik.values.street}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>

                <div className="detailsGrid">
                  <div>
                    <label>Area</label>
                    <input
                      type="text"
                      name="area"
                      value={formik.values.area}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  <div>
                    <label>City</label>
                    <input
                      type="text"
                      name="city"
                      value={formik.values.city}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>

                <div className="detailsGrid">
                  <div>
                    <label>District</label>
                    <input
                      type="text"
                      name="district"
                      value={formik.values.district}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  <div>
                    <label>State</label>
                    <input
                      type="text"
                      name="state"
                      value={formik.values.state}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>

                <div className="detailsGrid">
                  <div>
                    <label>Country</label>
                    <input
                      type="text"
                      name="country"
                      value={formik.values.country}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  <div>
                    <label>
                      <span className="text-danger">*</span> Pincode
                    </label>
                    <input
                      type="text"
                      name="pincode"
                      value={formik.values.pincode}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.pincode && formik.errors.pincode && (
                      <div className="error-message-signIn">
                        {formik.errors.pincode}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "bankdetails" && (
              <div className="detailsContainer">
                <div className="detailsGrid">
                  <div>
                    <label>Bank Account Number</label>
                    <input
                      type="text"
                      name="bank_account_number"
                      value={
                        isFocusedAccountNumber
                          ? formik.values.bank_account_number
                          : getMaskedAccountNumber(
                              formik.values.bank_account_number,
                            )
                      }
                      onFocus={() => setIsFocusedAccountNumber(true)}
                      onChange={formik.handleChange}
                      onBlur={(e) => {
                        setIsFocusedAccountNumber(false);
                        formik.handleBlur(e);
                      }}
                    />
                    {formik.touched.bank_account_number &&
                      formik.errors.bank_account_number && (
                        <div className="error-message-signIn">
                          {formik.errors.bank_account_number}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>IFSC Code</label>
                    <input
                      type="text"
                      name="ifsc_code"
                      value={formik.values.ifsc_code}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.ifsc_code && formik.errors.ifsc_code && (
                      <div className="error-message-signIn">
                        {formik.errors.ifsc_code}
                      </div>
                    )}
                  </div>
                  <div>
                    <label>
                      <span className="text-danger">*</span> Bank Name
                    </label>
                    <select
                      name="bank_name"
                      value={formik.values.bank_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option value="">Select Bank</option>
                      {bankOptions.map((bank, index) => (
                        <option key={index} value={bank}>
                          {bank}
                        </option>
                      ))}
                    </select>
                    {formik.touched.bank_name && formik.errors.bank_name && (
                      <div className="error-message-signIn">
                        {formik.errors.bank_name}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className="btnSaveContainer">
              <button type="submit">Save Changes</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
